module.exports = __webpack_public_path__ + "e6b5e204d3da700fbf9004584f69d6fa.svg";